import { Input } from "@web-app/components";
import { AppFilterType, OrderDeliveryType } from "@web-app/types";

import TabPanelTitle from "./TabPanelTitle";
import { TabPanelWrapper } from "./TabPanelWrapper";

export default function DeliveryTypeFilterTab({
  onChangeDeliveryType,
  temporaryAppFilter,
}: {
  onChangeDeliveryType: (
    value: string,
    deliveryType: OrderDeliveryType,
  ) => void;
  temporaryAppFilter: AppFilterType;
}) {
  return (
    <TabPanelWrapper>
      <TabPanelTitle>Delivery Type</TabPanelTitle>
      <div className="mb-4 md:mb-6 lg:mb-8 mt-1 md:mt-2 flex flex-col gap-1">
        <Input
          type="checkbox"
          rightLabel="Route Based Pickup"
          value={
            temporaryAppFilter.orderDeliveryType.includes(
              OrderDeliveryType.ROUTE_OPT_PICKUP,
            )
              ? "true"
              : "false"
          }
          onChange={(value) =>
            onChangeDeliveryType(value, OrderDeliveryType.ROUTE_OPT_PICKUP)
          }
        />
        <Input
          type="checkbox"
          rightLabel="Route Based Drop-off"
          value={
            temporaryAppFilter.orderDeliveryType.includes(
              OrderDeliveryType.ROUTE_OPT_DROPOFF,
            )
              ? "true"
              : "false"
          }
          onChange={(value) =>
            onChangeDeliveryType(value, OrderDeliveryType.ROUTE_OPT_DROPOFF)
          }
        />
        <Input
          type="checkbox"
          rightLabel="Point-to-Point"
          value={
            temporaryAppFilter.orderDeliveryType.includes(
              OrderDeliveryType.INDIVIDUAL_PICKUP_AND_DROPOFF,
            )
              ? "true"
              : "false"
          }
          onChange={(value) =>
            onChangeDeliveryType(
              value,
              OrderDeliveryType.INDIVIDUAL_PICKUP_AND_DROPOFF,
            )
          }
        />
      </div>
    </TabPanelWrapper>
  );
}
